import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { FaUsers, FaCalendarCheck, FaUmbrellaBeach, FaWalking, FaFileAlt, FaFileInvoiceDollar, FaPalette, FaBriefcase, FaArchive, FaUserCheck, FaTags, FaTachometerAlt, FaMapMarkerAlt, FaBell, FaEnvelope, FaCaretDown, FaRegAddressBook, FaCalendarAlt, FaBullhorn, FaUsersCog, FaHome, FaClipboardList, FaChartLine, FaUserFriends, FaPeopleCarry, FaHSquare } from "react-icons/fa";
import { IoHomeOutline, IoMenu } from "react-icons/io5";
import "./Navbar.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from "../../AuthContext/AuthContext";
import { baseURL } from "../../Apiservices/Api";
import { adminMail, headofSalesMail } from "../../Apiservices/Api";
import { ThemeContext } from "../Themes/ThemeContext";
import logo from '../../Images/Logo-funstay.png';
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Reminderactions from "./../../Pages/Admin/Potentialleads/Reminderactions"; 

const Navbar = ({ onToggleSidebar }) => {
  const [formData, setFormData] = useState({
    imageUrl: "",
  });
  const [collapsed, setCollapsed] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMenu, setShowMenu] = useState(false); // State for toggle menu
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, userName, userId, authToken, userEmail } = useContext(AuthContext);
  const { themeColor } = useContext(ThemeContext);
  const [notifications, setNotifications] = useState([]);
  const [emailNotifications, setEmailNotifications] = useState([]);
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
  const [showEmailNotificationDropdown, setShowEmailNotificationDropdown] = useState(false);
  const [emailCount, setEmailCount] = useState(0);

  // ── Reminder states (NEW) ─────────────────────────────────────────────────
  const [reminderAlerts, setReminderAlerts] = useState([]);
  const [pendingAlerts, setPendingAlerts] = useState([]);
  const [showReminderPanel, setShowReminderPanel] = useState(false);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedTravelOpportunityId, setSelectedTravelOpportunityId] = useState(null);
  const [currentAlertKey, setCurrentAlertKey] = useState(null);
  const [resolvedUserId, setResolvedUserId] = useState(null);

  // ── Reminder helpers (NEW) ────────────────────────────────────────────────
  const getStoredAlerts = () => {
    try { return JSON.parse(localStorage.getItem("shownAlerts") || "[]"); }
    catch { return []; }
  };
  const getStoredPendingAlerts = () => {
    try { return JSON.parse(localStorage.getItem("pendingAlerts") || "[]"); }
    catch { return []; }
  };
  const shownAlerts = useRef(new Set(getStoredAlerts()));

  const truncateText = (text, limit = 40) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  useEffect(() => {
    const stored = getStoredPendingAlerts();
    if (stored.length > 0) setPendingAlerts(stored);
  }, []);

  useEffect(() => {
    setResolvedUserId(userId || localStorage.getItem("userId"));
  }, [userId]);

  useEffect(() => {
    localStorage.setItem("pendingAlerts", JSON.stringify(pendingAlerts));
  }, [pendingAlerts]);

  const markAlertAsRead = (alertKey) => {
    setPendingAlerts(prev => prev.filter(a => a.key !== alertKey));
  };

  const clearAllAlerts = () => {
    setPendingAlerts([]);
    localStorage.removeItem("pendingAlerts");
    shownAlerts.current.clear();
    localStorage.removeItem("shownAlerts");
    setShowReminderPanel(false);
  };

  const handleAlertClick = (alertKey, leadid, travelOpportunityId) => {
    setSelectedLeadId(leadid);
    setSelectedTravelOpportunityId(travelOpportunityId);
    setCurrentAlertKey(alertKey);
    setShowReminderModal(true);
  };

  const handleActionSuccess = () => {
    if (currentAlertKey) {
      markAlertAsRead(currentAlertKey);
      setCurrentAlertKey(null);
    }
    setShowReminderModal(false);
    setSelectedLeadId(null);
    setSelectedTravelOpportunityId(null);
  };

  const handleCloseReminderModal = () => {
    setShowReminderModal(false);
    setSelectedLeadId(null);
    setSelectedTravelOpportunityId(null);
    setCurrentAlertKey(null);
  };

  const checkReminders = useCallback(async () => {
    const id = userId || localStorage.getItem("userId");
    if (!id) return;
    try {
      const { data } = await axios.get(`${baseURL}/api/check-reminders`, {
        params: { userId: id },
      });
      const currentPending = getStoredPendingAlerts();
      data.forEach((reminder) => {
        const key = `${reminder.id}-${reminder.label}`;
        const isInPending = currentPending.some((a) => a.key === key);
        if (!shownAlerts.current.has(key) && !isInPending) {
          shownAlerts.current.add(key);
          localStorage.setItem("shownAlerts", JSON.stringify(Array.from(shownAlerts.current)));
          const correctLeadId = reminder.lead_id || reminder.leadid;
          const correctTravelOppId = reminder.travel_opportunity_id;
          const newAlert = {
            key,
            reminder,
            leadid: correctLeadId,
            travelOpportunityId: correctTravelOppId,
            message: `${reminder.label}: Lead ${correctLeadId} : Note ${truncateText(reminder.notes)}`,
            timestamp: Date.now(),
          };
          setPendingAlerts((prev) => {
            if (prev.some((a) => a.key === newAlert.key)) return prev;
            return [...prev, newAlert];
          });
          setReminderAlerts((prev) => [...prev, { ...newAlert, isBlinking: true }]);
          setTimeout(() => {
            setReminderAlerts((prev) => prev.filter((a) => a.key !== newAlert.key));
          }, 15000);
        }
      });
    } catch (error) {
      console.error("Error checking reminders:", error);
    }
  }, [userId]);

  useEffect(() => {
    checkReminders();
    const interval = setInterval(checkReminders, 30000);
    return () => clearInterval(interval);
  }, [checkReminders]);

  // ── Close all dropdowns on outside click (NEW) ────────────────────────────
  useEffect(() => {
    const handleOutsideClick = () => {
      setShowReminderPanel(false);
      setShowEmailNotificationDropdown(false);
      setShowNotificationDropdown(false);
      setShowDropdown(false);
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  // ── Original Navbar logic (UNCHANGED) ────────────────────────────────────

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    onToggleSidebar(!collapsed);
  };

  useEffect(() => {
    // Fetch employee details when the component mounts
    const fetchEmployeeDetails = async () => {
      try {
        const response = await fetch(`${baseURL}/employee/${userId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        const data = await response.json();
        setFormData({
          imageUrl: data.image || "", // Assuming image URL is returned
        });
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchEmployeeDetails();
  }, [userId, authToken]);

  const handleNavItemClick = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);
    }
  };

  const handleProfileClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    logout(); // Clears authToken, userRole, and userId
    console.log('Logged out');
    navigate('/'); // Redirect to the home or login page
  };

  const toggleNotificationDropdown = () => {
    setShowNotificationDropdown(!showNotificationDropdown);
    setShowEmailNotificationDropdown(false); // Close email dropdown if open
  };

  const toggleEmailNotificationDropdown = () => {
    setShowEmailNotificationDropdown(!showEmailNotificationDropdown);
    setShowNotificationDropdown(false); // Close bell dropdown if open
  };

  const markNotificationAsRead = async (notificationId) => {
    try {
      await fetch(`${baseURL}/api/notifications/${notificationId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ read: true }),
      });
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleNotificationClick = async (notification) => {
    await markNotificationAsRead(notification.id);
    setNotifications((prev) => prev.filter((n) => n.id !== notification.id));
    setShowNotificationDropdown(false);

    // Navigate based on whether the notification has a leadid
    if (notification.leadid) {
      navigate(`/a-opportunity-comments/${notification.leadid}`);
    } else {
      navigate('/a-view-lead');
    }

    // Use a timeout to ensure navigation happens before the reload
    setTimeout(() => {
      window.location.reload();
    }, 0);
  };

  // const fetchNotifications = async () => {
  //   try {
  //     const response = await fetch(`${baseURL}/email/notifications?managerid=${adminMail}`);
  //     const data = await response.json();
  //     setNotifications(data.notifications || []); // Fallback to empty array if undefined
  //   } catch (error) {
  //     console.error("Error fetching notifications:", error);
  //     setNotifications([]); // Set to empty array on error
  //   }
  // };

  const fetchEmailNotifications = async () => {
    try {
      const response = await fetch(`${baseURL}/api/email/notifications`);
      const data = await response.json();
      const emails = data.emailnotifications || []; // Fallback to empty array if undefined
      setEmailNotifications(emails);
      // setEmailCount(emails.length);
    } catch (error) {
      console.error("Error fetching email notifications:", error);
      setEmailNotifications([]); // Set to empty array on error
      // setEmailCount(0);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      // await fetchNotifications();
      await fetchEmailNotifications();
    };

    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, [userId]);

  const markEmailNotificationAsRead = async (emailnotificationId) => {
    try {
      await fetch(`${baseURL}/api/email/notifications/${emailnotificationId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ read: true }),
      });
    } catch (error) {
      console.error("Error marking email notification as read:", error);
    }
  };

  const handleEmailNotificationClick = async (emailnotification) => {
    await markEmailNotificationAsRead(emailnotification.id);
    setEmailNotifications((prev) => prev.filter((n) => n.id !== emailnotification.id));
    setShowEmailNotificationDropdown(false);

    // Navigate based on whether the notification has a leadid
    if (emailnotification.leadid) {
      navigate(`/email-history/${emailnotification.leadid}`, { state: { email: emailnotification.email } });
    } else {
      navigate('/a-potential-leads');
    }
  };

  return (
    <>
      <div className="admin-container">
        <div className="admin-header" style={{ "--theme-color": themeColor }}>
          <div className="admin-header-left">
            <div
              className={`admin-sidebar-toggle ${collapsed ? 'collapsed' : ''}`}
              onClick={toggleSidebar}
            >
              <IoMenu className="toggle-icon" />
            </div> &nbsp;&nbsp;
            {/* <img src={'https://primary0101211.s3.ap-south-1.amazonaws.com/v3/assets/images/Logo.png'} alt="Logo" className="admin-company-logo" /> */}
                      <img src={logo} alt="Logo" className="admin-company-logo" />

          </div>
          <h2 className="text-center user-admin" style={{ color: 'white' }}>
            {userEmail === headofSalesMail ? "Head of Sales" : userName}
          </h2>
          <div className="admin-header-right">
            <div className="admin-header-icons">

          

              {/* Original notification bell (kept exactly as original — icon hidden, dropdown logic kept) */}
              <div className="admin-nav-icon-container" onClick={(e) => { e.stopPropagation(); toggleNotificationDropdown(); }}>
                    
              <div
                className="admin-nav-icon-container"
                style={{ position: "relative" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowReminderPanel(prev => !prev);
                  setShowEmailNotificationDropdown(false);
                  setShowNotificationDropdown(false);
                  setShowDropdown(false);
                }}
              >
                <FaBell className="admin-nav-icon" />
                {pendingAlerts.length > 0 && (
                  <span className="admin-nav-badge">{pendingAlerts.length}</span>
                )}

                {showReminderPanel && (
                  <div
                    className="notification-dropdown"
                    style={{
                      position: "absolute",
                      top: "calc(100% + 8px)",
                      right: 0,
                      width: 350,
                      background: "#fff",
                      borderRadius: 8,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                      overflow: "hidden",
                      zIndex: 10001,
                    }}
                  >
                    {/* Panel header */}
                    <div
                      className="notification-dropdown-header"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#ff9800",
                        padding: "10px 14px",
                        color: "#fff",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span style={{ fontWeight: 600, fontSize: "14px" }}>
                        Reminders ({pendingAlerts.length})
                      </span>
                      <div style={{ display: "flex", gap: 8 }}>
                        {pendingAlerts.length > 0 && (
                          <button
                            onClick={(e) => { e.stopPropagation(); clearAllAlerts(); }}
                            style={{ background: "#f44336", color: "white", border: "none", padding: "4px 10px", borderRadius: 4, cursor: "pointer", fontSize: 12, fontWeight: "bold" }}
                          >
                            Clear All
                          </button>
                        )}
                        <button
                          onClick={(e) => { e.stopPropagation(); setShowReminderPanel(false); }}
                          style={{ background: "none", border: "none", color: "#fff", fontSize: 18, cursor: "pointer" }}
                        >
                          ✕
                        </button>
                      </div>
                    </div>

                    {/* Panel body */}
                    <div
                      className="notification-dropdown-body"
                      style={{ maxHeight: 300, overflowY: "auto" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {pendingAlerts.length === 0 ? (
                        <div className="notification-item" style={{ textAlign: "center", color: "#999", padding: 30 }}>
                          No new reminders
                        </div>
                      ) : (
                        pendingAlerts.map((alert) => (
                          <div
                            key={alert.key}
                            className="notification-item"
                            style={{ padding: "10px 14px", borderBottom: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}
                          >
                            <div
                              style={{ flex: 1, minWidth: 0, cursor: "pointer" }}
                              onClick={() => resolvedUserId && handleAlertClick(alert.key, alert.leadid, alert.travelOpportunityId)}
                            >
                              <div style={{ fontSize: 13, color: "#333", wordBreak: "break-word" }}>{alert.message}</div>
                              <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>{new Date(alert.timestamp).toLocaleTimeString()}</div>
                            </div>
                            <button
                              onClick={(e) => { e.stopPropagation(); markAlertAsRead(alert.key); }}
                              style={{ background: "none", border: "none", color: "#bbb", fontSize: 14, cursor: "pointer", padding: "2px 6px" }}
                              title="Dismiss"
                            >✕</button>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
                {/* <FaBell className="admin-nav-icon" />
                {(notifications?.length || 0) > 0 && (
                  <span className="admin-nav-badge">{notifications?.length || 0}</span>
                )} */}
                {/* {showNotificationDropdown && (
                  <div className="notification-dropdown">
                    <div className="notification-dropdown-header">Notifications</div>
                    <div className="notification-dropdown-body">
                      {!notifications || notifications.length === 0 ? (
                        <div className="notification-item">No new notifications</div>
                      ) : (
                        notifications.map((notification) => (
                          <div
                            key={notification.id}
                            className="notification-item"
                            onClick={() => handleNotificationClick(notification)}
                            style={{ padding: "8px", cursor: "pointer" }}
                          >
                            <div style={{ fontWeight: notification.read ? "normal" : "bold" }}>
                              {notification.message.length > 40
                                ? `${notification.message.slice(0, 40)}...`
                                : notification.message}
                            </div>
                            <div style={{ fontSize: "0.8em", color: "#888" }}>

                              {new Date(notification.createdAt).toLocaleString('en-IN', {
                                timeZone: 'Asia/Kolkata',
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: false
                              })}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )} */}
              </div>

              <div className="admin-nav-icon-container" onClick={(e) => { e.stopPropagation(); toggleEmailNotificationDropdown(); }}>
                <FaEnvelope className="admin-nav-icon" />
                {(emailNotifications?.length || 0) > 0 && (
                  <span className="admin-nav-badge">{emailNotifications.length}</span>
                )}
                {showEmailNotificationDropdown && (
                  <div className="notification-dropdown">
                    <div className="notification-dropdown-header">Email Notifications</div>
                    <div className="notification-dropdown-body">
                      {(!emailNotifications || emailNotifications.length === 0) ? (
                        <div className="notification-item">No new email notifications</div>
                      ) : (
                        emailNotifications.map((emailnotification) => (
                          <div
                            key={emailnotification.id}
                            className="notification-item"
                            onClick={() => handleEmailNotificationClick(emailnotification)}
                            style={{ padding: "8px", cursor: "pointer" }}
                          >
                            <div style={{ fontWeight: emailnotification.read ? "normal" : "bold" }}>
                              {emailnotification.text?.length > 40
                                ? `${emailnotification.text.slice(0, 40)}...`
                                : emailnotification.text}
                            </div>
                            <div style={{ fontSize: "0.8em", color: "#888" }}>
                              {new Date(emailnotification.created_at).toLocaleString('en-IN', {
                                timeZone: 'Asia/Kolkata',
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: false
                              })}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>


              <div className="admin-nav-icon-container">
                <Link className="nav-link" to="/themes">

                  <FaPalette className="admin-nav-icon" style={{ cursor: "pointer" }} />
                </Link>
              </div>


              <div className="admin-nav-icon-container" onClick={(e) => { e.stopPropagation(); handleProfileClick(); }}>
                <div className="admin-nav-profile">

                  {formData.imageUrl ? (
                    <img
                      src={`${baseURL}${formData.imageUrl}`}
                      alt="Profile"
                      className="admin-nav-profile-img"
                    />
                  ) : (
                    <img
                      src="https://i.pravatar.cc/100?img=4" // Fallback image
                      alt="Default Profile"
                      className="admin-nav-profile-img"
                    />
                  )}
                  {/* <img
                    src="https://i.pravatar.cc/40?img=4"
                    alt="Profile"
                    className="admin-nav-profile-img"
                  /> */}
                  <FaCaretDown className="admin-nav-caret-icon" />
                </div>
                {showDropdown && (
                  <div className="admin-nav-profile-dropdown">
                    <div className="admin-nav-profile-header">
                      <strong>{userName}</strong>
                    </div>
                    <div
                      className="admin-nav-profile-item"
                      onClick={() => navigate("/a-profile")}
                    >
                      Your Profile
                    </div>
                    {userEmail !== headofSalesMail && (
                    <div className="admin-nav-profile-item"
                    onClick={() => navigate("/A_table_emailcredentials")}>Email Credentials</div>)}
                    {/* <div className="admin-nav-profile-item">Settings</div>
                    <div className="admin-nav-profile-item">Help Center</div> */}
                    <div className="admin-nav-profile-item" onClick={handleLogout}>Sign Out</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`} style={{ "--theme-color": themeColor }}>
        <div className="admin-position-sticky">
          <ul className="nav flex-column">
            <li className={`admin-nav-item ${location.pathname.startsWith("/dashboard") ? "active"
              : ""
              }`}>
              <Link className="nav-link" to="/dashboard" onClick={handleNavItemClick}>
                <FaHome className="admin-nav-icon" />
                {!collapsed && <span className="link_text">Dashboard</span>}
              </Link>
            </li>

            <li
              className={`admin-nav-item ${location.pathname.startsWith("/a-view-lead") ||
                location.pathname.startsWith("/a-edit-lead") ||
                location.pathname.startsWith("/a-add-leads") ||
                location.pathname.startsWith("/a-comments") ||
                location.pathname.startsWith("/a-view-lead") ||
                location.pathname.startsWith("/a-create-customer-opportunity")
                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/a-view-lead" onClick={handleNavItemClick}>
                <FaClipboardList className="admin-nav-icon" />
                {!collapsed && <span className="link_text">All Leads</span>}
              </Link>
            </li>
            <li
              className={`admin-nav-item ${location.pathname.startsWith("/a-myleads") ||
                location.pathname.startsWith("/a-myedit-lead") ||
                location.pathname.startsWith("/a-myadd-leads") ||
                location.pathname.startsWith("/a-mycomments") ||
                location.pathname.startsWith("/a-myview-lead") ||
                location.pathname.startsWith("/a-mycreate-customer-opportunity")
                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/a-myleads" onClick={handleNavItemClick}>
                <FaUserCheck className="admin-nav-icon" />
                {!collapsed && <span className="link_text">My Leads</span>}
              </Link>
            </li>
            <li
              className={`admin-nav-item ${location.pathname.startsWith("/a-potential-leads") ||
                location.pathname.startsWith("/a-edit-opportunity") ||
                location.pathname.startsWith("/a-opportunity-comments") ||
                location.pathname.startsWith("/a-details") ||
                location.pathname.startsWith("/email-history") ||
                location.pathname.startsWith("/a-payments") ||
                location.pathname.startsWith("/a-add-payment") ||
                location.pathname.startsWith("/a-supplier") ||
                location.pathname.startsWith("/a-add-supplier") ||
                location.pathname.startsWith("/a-suppliers") ||
                location.pathname.startsWith("/a-suppliers/history") ||
                location.pathname.startsWith("/a-edit-payment") ||
                location.pathname.startsWith("/a-edit-suppayment")
                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/a-potential-leads" onClick={handleNavItemClick}>
                <FaChartLine className="admin-nav-icon" />
                {!collapsed && <span className="link_text">All Opportunities</span>}
              </Link>
            </li>
            <li
              className={`admin-nav-item ${location.pathname.startsWith("/a-myopp") ||
                location.pathname.startsWith("/a-myedit-opportunity") ||
                location.pathname.startsWith("/a-myopportunity-comments") ||
                location.pathname.startsWith("/a-mydetails") ||
                location.pathname.startsWith("/a_myemail-history") ||
                location.pathname.startsWith("/a-mypayments") ||
                location.pathname.startsWith("/a-add-mypayment") ||
                location.pathname.startsWith("/a-mysupplier") ||
                location.pathname.startsWith("/a-add-mysupplier") ||
                location.pathname.startsWith("/a-mysuppliers") ||
                location.pathname.startsWith("/a-mysuppliers/history") ||
                location.pathname.startsWith("/a-edit-mysuppayment")
                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/a-myopp" onClick={handleNavItemClick}>
                <FaBriefcase className="admin-nav-icon" />
                {!collapsed && <span className="link_text">My Opportunities</span>}
              </Link>
            </li>
            <li
              className={`admin-nav-item ${location.pathname.startsWith("/a-customers") ||
                location.pathname.startsWith("/a-customer-details") ||
                location.pathname.startsWith("/a-customerdetails") ||
                location.pathname.startsWith("/a-editcustomerdetails")

                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/a-customers" onClick={handleNavItemClick}>
                <FaUserFriends className="admin-nav-icon" />
                {!collapsed && <span className="link_text">All customer</span>}
              </Link>
            </li>
            {userEmail !== headofSalesMail && (
              <>
                <li
                  className={`admin-nav-item ${location.pathname.startsWith("/a-destinations") ? "active" : ""
                    }`}
                >
                  <Link className="nav-link" to="/a-destinations" onClick={handleNavItemClick}>
                    <FaMapMarkerAlt className="admin-nav-icon" />
                    {!collapsed && <span className="link_text">All Destinations</span>}
                  </Link>
                </li>

                <li
                  className={`admin-nav-item ${location.pathname.startsWith("/a-tags") ? "active" : ""
                    }`}
                >
                  <Link className="nav-link" to="/a-tags" onClick={handleNavItemClick}>
                    <FaTags className="admin-nav-icon" />
                    {!collapsed && <span className="link_text">All Tags</span>}
                  </Link>
                </li>

                 <li
                  className={`admin-nav-item ${location.pathname.startsWith("/a-whatsapp-templates") ? "active" : ""
                    }`}
                >
                  <Link className="nav-link" to="/a-whatsapp-templates" onClick={handleNavItemClick}>
                    <FaTags className="admin-nav-icon" />
                    {!collapsed && <span className="link_text">Whatsapp Templates</span>}
                  </Link>
                </li>

                 <li
                  className={`admin-nav-item ${location.pathname.startsWith("/a-lead-status") ? "active" : ""
                    }`}
                >
                  <Link className="nav-link" to="/a-lead-status" onClick={handleNavItemClick}>
                    <FaTags className="admin-nav-icon" />
                    {!collapsed && <span className="link_text">Add Status</span>}
                  </Link>
                </li>

                 {/* <li
                  className={`admin-nav-item ${location.pathname.startsWith("/a-lead-opp-status") ? "active" : ""
                    }`}
                >
                  <Link className="nav-link" to="/a-lead-opp-status" onClick={handleNavItemClick}>
                    <FaTags className="admin-nav-icon" />
                    {!collapsed && <span className="link_text">Add Opportunity Status</span>}
                  </Link>
                </li> */}

              </>
            )}
            <li
              className={`admin-nav-item ${location.pathname.startsWith("/a-approvals") ||
                location.pathname.startsWith("/a-approval-supplier") ||
                location.pathname.startsWith("/a-edit-approval-payment") ||
                location.pathname.startsWith("/a-edit-sup-approval-payment")
               

                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/a-approvals" onClick={handleNavItemClick}>
                <FaUserFriends className="admin-nav-icon" />
                {!collapsed && <span className="link_text"> Approvals</span>}
              </Link>
            </li>
          


            <li
              className={`admin-nav-item ${location.pathname.startsWith("/A_Report")


                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/A_Report" onClick={handleNavItemClick}>
                <FaFileAlt className="admin-nav-icon" />
                {!collapsed && <span className="link_text">Report </span>}
              </Link>



            </li>
            {userEmail !== headofSalesMail && (
              <li
                className={`admin-nav-item ${location.pathname.startsWith("/admin-supplierlist") ||
                  location.pathname.startsWith("/admin-add-supplier") ||
                  location.pathname.startsWith("/admin-edit-supplier") 
                   ? "active" : ""
                  }`}
              >
                <Link className="nav-link" to="/admin-supplierlist" onClick={handleNavItemClick}>
                  <FaTags className="admin-nav-icon" />
                  {!collapsed && <span className="link_text">Suppliers</span>}
                </Link>
              </li>
            )}
  <li
              className={`admin-nav-item ${location.pathname.startsWith("/a-archivedata")


                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/a-archivedata" onClick={handleNavItemClick}>
                <FaArchive className="admin-nav-icon" />
                {!collapsed && <span className="link_text">Archieved Data </span>}
              </Link>



            </li>
            <li
              className={`admin-nav-item ${location.pathname.startsWith("/a-allteams") ||
                location.pathname.startsWith("/addemployee") ||
                location.pathname.startsWith("/team-members") ||
                location.pathname.startsWith("/editemployee")

                ? "active"
                : ""
                }`}
            >
              <Link className="nav-link" to="/a-allteams" onClick={handleNavItemClick}>
                <FaPeopleCarry className="admin-nav-icon" />
                {!collapsed && <span className="link_text">All Teams </span>}
              </Link>



            </li>


          </ul>
        </div>
      </div>

      {/* ── Blinking Toast Alerts (NEW) — positioned below navbar so it never covers icons ── */}
      {reminderAlerts.length > 0 && (
        <div style={{ position: "fixed", top: 70, right: 20, zIndex: 9998 }}>
          {reminderAlerts.map((alert) => (
            <div
              key={alert.key}
              style={{
                background: "#fff",
                padding: "12px 16px",
                marginBottom: 10,
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                borderLeft: "4px solid #ff9800",
                minWidth: 250,
                cursor: "pointer",
                animation: alert.isBlinking ? "reminderBlink 0.5s ease-in-out 3" : "none",
              }}
              onClick={() => resolvedUserId && handleAlertClick(alert.key, alert.leadid, alert.travelOpportunityId)}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 13 }}>{alert.message}</span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setReminderAlerts((prev) => prev.filter((a) => a.key !== alert.key));
                  }}
                  style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", marginLeft: 10 }}
                >
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ── Reminder Modal (NEW) ── */}
      <Modal
        show={showReminderModal}
        onHide={handleCloseReminderModal}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Reminder Actions - Lead ID: {selectedLeadId}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          {selectedLeadId && resolvedUserId ? (
            <Reminderactions
              leadid={selectedLeadId}
              travelOpportunityId={selectedTravelOpportunityId}
              userId={resolvedUserId}
              onActionSuccess={handleActionSuccess}
            />
          ) : (
            <div style={{ padding: 20, textAlign: "center", color: "red" }}>
              Error: User ID not available. Please refresh the page.
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ── Blink animation (NEW) ── */}
      <style>{`
        @keyframes reminderBlink {
          0%, 100% { opacity: 1; background: #fff; }
          50%       { opacity: 0.7; background: #fff3e0; border-left-color: #ff5722; }
        }
      `}</style>
    </>
  );
};

export default Navbar;